import React, { createContext, useState } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [course, setCourse] = useState(null);
    const [user, setUser] = useState(null); // State to store user details    
    
    return (
        <AuthContext.Provider value={{ user, setUser, course, setCourse }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthProvider };

